export { default } from './Slider';
export type { Props } from './Slider';
